import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {LinedTableProps} from './LinedTableProps.interface';

/**
 * 디자인시스템화 되어있진 않지만 피그마 상에 Table 로 된 컴포넌트입니다
 * https://www.figma.com/file/VnJWFW7CQnDri5lKEDc9Ol/NEXT_%EC%B5%9C%EC%A2%85-%EC%B7%A8%ED%95%A9_APP%26WEB?node-id=32790-610406&t=PhBKvlXGALTqRqHG-4
 */
export function LinedTable({rowList, className, ...props}: LinedTableProps) {
  return (
    <div className={className} {...props}>
      {rowList.map(({head, headAddition, cell}, index) => (
        <div
          key={head}
          className={twMerge(
            'box-border flex min-h-[42px] border-theme-solid-20',
            index === 0 ? 'border-y-1' : 'border-b-1'
          )}
        >
          <div
            className={twMerge(
              'box-border w-[121px] items-center border-r-1 border-theme-solid-20 bg-theme-solid-10 py-12px pl-12px'
            )}
          >
            <Text className="font-small1 text-theme-solid-100">{head}</Text>
            {headAddition && (
              <>
                <br />
                <Text className="font-small1 text-theme-solid-40">
                  {headAddition}
                </Text>
              </>
            )}
            <br />
          </div>
          <div
            className={twMerge(
              'font-small1 flex grow items-center justify-end p-12px'
            )}
          >
            <Text className="text-right text-theme-solid-100">{cell}</Text>
          </div>
        </div>
      ))}
    </div>
  );
}
